import { render, staticRenderFns } from "./phLogin.vue?vue&type=template&id=57131cbc"
import script from "./phLogin.vue?vue&type=script&lang=js"
export * from "./phLogin.vue?vue&type=script&lang=js"
import style0 from "./phLogin.vue?vue&type=style&index=0&id=57131cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports